import "../../assets/css/requests/reviewForAuth.css"

import back from "../../assets/images/arrowForward.svg"
import save from "../../assets/images/save.svg"
import cvpBadge from "../../assets/images/CVPBagdeProfile.png"
import starRating from "../../assets/images/starRating.svg"
import profileExample from "../../assets/images/profileExample.png"

import React, { useEffect, useRef, useState } from "react";
import { useReviewForAuthData, useReviewForAuthMutations } from "./reviewForAuth/hooks"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import InformationCompliance from "../tabs/informationCompliance.jsx";
import QualitySurvey from "../tabs/qualitySurvey.jsx";
import DocumentComplianceTable from "../tabs/documentCompliance/documentComplianceTable.jsx"
import AddClientUserModal from "../clientsAdminView/addClientUserModal.jsx"

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Swal from "sweetalert2"
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import ProductsAndServices from "../tabs/productAndService.jsx";
import Contracts from "../tabs/contracts.jsx";
import StaffList from "../tabs/staff/staffList.jsx"
import { checkInformationCompliance } from "../../utilities/utils.js"
import addIcon from "../../assets/images/add.svg"
import UsersTab from "../suppliers/UsersTab.jsx"
import { useAuth } from "../../context/auth-user.jsx"

const {
	REACT_APP_URI_SEND_NOTIFICATION: URI_NOTIFICATION,
	REACT_APP_URI_PRE_AUTH_SUPPLIER: URI_PRE_AUTH_SUPPLIER,
} = process.env

// MODAL TO SHOW THE CLIENT LIST
function SupplierClientsModalReviewForAuth(props) {
	const navigate = useNavigate()

	async function handleAction(clientID, status) {
		await props.handleStatusChange(clientID, status)
	}

	async function preAuthorizeSupplier(supplierId, clientID) {
		try {
			Swal.fire({
				footer: 'Loading, please wait',
				showConfirmButton: false,
				allowOutsideClick: false,
				allowEscapeKey: false,
				didOpen: () => {
					Swal.showLoading()
				},
			})

			const { data } = await axios.patch(`${URI_PRE_AUTH_SUPPLIER}${supplierId}`, {
				clientID: clientID,
				userLogged: props.userLogged
			})

			await Swal.fire({
				icon: 'success',
				text: data.message,
				showConfirmButton: false,
				timer: 5000,
				timerProgressBar: true,
			})

			window.location.reload()
		} catch (error) {
			Swal.fire({
				icon: 'error',
				text: error.response?.data?.message || 'Error pre-authorizing supplier',
				showConfirmButton: false,
				timer: 5000,
				timerProgressBar: true,
			})
		}
	}

	return (
		<Modal
			className="supplierClientsModalReviewForAuth"
			size="lg"
			centered
			show={props.show}
			onHide={props.onHide}
		>
			<Modal.Body>
				<h5 className="commentTitle">Clients</h5>
				<table className="tableClients">
					<thead>
						<tr>
							<th><span>Name</span></th>
							<th><span>Status</span></th>
							<th><span className="w-100" style={{ justifyContent: "flex-end" }}>Actions</span></th>
						</tr>
					</thead>
					<tbody>
						{props.supplierClients && props.supplierClients.map((supplierClient, index) => {
							switch (props.userLogged?.rol) {
								case "Master":
								case "Super admin":
									return (
										<tr key={index}>
											<td>
												<div className="infoContainer">
													<span>{props.clients && props.clients.find(clients => clients.entities.find(entity => entity._id === supplierClient.clientID)).entities.find(entity => entity._id === supplierClient.clientID).entityName}</span>
												</div>
											</td>
											<td>
												<div className="infoContainer">
													<span className={`${supplierClient.status === "Ready for review" || supplierClient.status === "Active" ? "success" : ""} ${supplierClient.status === "Pre-authorized" || supplierClient.status === "Review requested" ? "pending" : ""} ${supplierClient.status === "New request" ? "new" : ""}`}>
														{supplierClient.status}
													</span>
												</div>
											</td>
											<td>
												<div className="infoContainer">
													<span className="actions">
														{supplierClient.status === "Ready for review" || supplierClient.status === "Pre-authorized" || supplierClient.status === "Review requested" ?
															<>
																<OverlayTrigger placement="top"
																	overlay={
																		<Tooltip id="activeTooltip">
																			Active
																		</Tooltip>
																	}
																>
																	<div onClick={() => handleAction(supplierClient.clientID, "Active")} />
																</OverlayTrigger>
																<OverlayTrigger placement="top"
																	overlay={
																		<Tooltip id="authorizeTooltip">
																			Authorize
																		</Tooltip>
																	}
																>
																	<div onClick={() => handleAction(supplierClient.clientID, "Authorized")} />
																</OverlayTrigger>
																<OverlayTrigger placement="top"
																	overlay={
																		<Tooltip id="rejectTooltip">
																			Reject
																		</Tooltip>
																	}
																>
																	<div onClick={() => handleAction(supplierClient.clientID, "Rejected")} />
																</OverlayTrigger>
																<OverlayTrigger placement="top"
																	overlay={
																		<Tooltip id="reviewTooltip">
																			Request Review
																		</Tooltip>
																	}
																>
																	<div onClick={() => handleAction(supplierClient.clientID, "Review requested")} />
																</OverlayTrigger>
															</> :
															supplierClient.status === "New request" ?
															<>
																<OverlayTrigger placement="top"
																	overlay={
																		<Tooltip id="activeTooltip">
																			Pre-authorize
																		</Tooltip>
																	}
																>
																	<div onClick={() => preAuthorizeSupplier(props.supplier._id, supplierClient.clientID)} />
																</OverlayTrigger>
															</> :
															<React.Fragment>
																{"No actions required"}
																<button className="btnBgBlueTextGradient" onClick={() => navigate("/home/suppliers/supplierProfile/" + props.supplier._id)}>
																	Profile</button>
															</React.Fragment>
														}
													</span>
												</div>
											</td>
										</tr>
									)

								case "Admin client":
								case "Admin Compliance manager":
									const clientEntitiesIDs = props.clients && props.clients.find(client => client._id.toString() === props.userLogged.dataID.toString()).entities.map(entity => entity._id.toString())
									return (
										clientEntitiesIDs && clientEntitiesIDs.includes(supplierClient.clientID) && <tr key={index}>
											<td>
												<div className="infoContainer">
													<span>{props.clients && props.clients.find(clients => clients.entities.find(entity => entity._id === supplierClient.clientID)).entities.find(entity => entity._id === supplierClient.clientID).entityName}</span>
												</div>
											</td>
											<td>
												<div className="infoContainer">
													<span className={`${supplierClient.status === "Ready for review" || supplierClient.status === "Active" ? "success" : ""} ${supplierClient.status === "Pre-authorized" || supplierClient.status === "Review requested" ? "pending" : ""} ${supplierClient.status === "New request" ? "new" : ""}`}>
														{supplierClient.status}
													</span>
												</div>
											</td>
											<td>
												<div className="infoContainer">

													<span className="actions">
														{supplierClient.status === "Ready for review" || supplierClient.status === "Pre-authorized" || supplierClient.status === "Review requested" ?
															<>
																<OverlayTrigger placement="top"
																	overlay={
																		<Tooltip id="activeTooltip">
																			Active
																		</Tooltip>
																	}
																>
																	<div onClick={() => handleAction(supplierClient.clientID, "Active")} />
																</OverlayTrigger>
																<OverlayTrigger placement="top"
																	overlay={
																		<Tooltip id="authorizeTooltip">
																			Authorize
																		</Tooltip>
																	}
																>
																	<div onClick={() => handleAction(supplierClient.clientID, "Authorized")} />
																</OverlayTrigger>
																<OverlayTrigger placement="top"
																	overlay={
																		<Tooltip id="rejectTooltip">
																			Reject
																		</Tooltip>
																	}
																>
																	<div onClick={() => handleAction(supplierClient.clientID, "Rejected")} />
																</OverlayTrigger>
																<OverlayTrigger placement="top"
																	overlay={
																		<Tooltip id="reviewTooltip">
																			Request Review
																		</Tooltip>
																	}
																>
																	<div onClick={() => handleAction(supplierClient.clientID, "Review requested")} />
																</OverlayTrigger>
															</> :
															supplierClient.status === "New request" ?
															<>
																<OverlayTrigger placement="top"
																	overlay={
																		<Tooltip id="activeTooltip">
																			Pre-authorize
																		</Tooltip>
																	}
																>
																	<div onClick={() => preAuthorizeSupplier(props.supplier._id, supplierClient.clientID)} />
																</OverlayTrigger>
															</> :
															"No actions required"
														}
													</span>
												</div>
											</td>
										</tr>
									)

								default:
									return null
							}
						})}
					</tbody>
				</table>

				<div className="d-lg-none mobileCientList">
					{props.supplierClients && props.supplierClients.map((supplierClient, index) => {
						switch (props.userLogged.rol) {
							case "Master":
							case "Super admin":
								return (
									<div key={index} className="clientRow">
										<span className="clientHeaderTitle">{props.clients.find(clients => clients.entities.find(entity => entity._id === supplierClient.clientID)).entities.find(entity => entity._id === supplierClient.clientID).entityName}</span>
										<span className={`clientValue ${(() => {
											switch (supplierClient.status) {
												case "Active":
												case "Ready for review":
													return "success"

												case "Pre-authorized":
												case "Review requested":
													return "pending"

												case "New request":
													return "new"

												case "Rejected":
													return "failed"

												default:
													break;
											}
										})()}`}>
											{supplierClient.status}
										</span>
										<span className="clientTitle">Status</span>
										<span className="clientValue actions">
											{supplierClient.status === "Ready for review" || supplierClient.status === "Pre-authorized" || supplierClient.status === "Review requested" ?
												<>
													<OverlayTrigger placement="top"
														overlay={
															<Tooltip id="activeTooltip">
																Active
															</Tooltip>
														}
													>
														<div onClick={() => handleAction(supplierClient.clientID, "Active")} />
													</OverlayTrigger>
													<OverlayTrigger placement="top"
														overlay={
															<Tooltip id="authorizeTooltip">
																Authorize
															</Tooltip>
														}
													>
														<div onClick={() => handleAction(supplierClient.clientID, "Authorized")} />
													</OverlayTrigger>
													<OverlayTrigger placement="top"
														overlay={
															<Tooltip id="rejectTooltip">
																Reject
															</Tooltip>
														}
													>
														<div onClick={() => handleAction(supplierClient.clientID, "Rejected")} />
													</OverlayTrigger>
													<OverlayTrigger placement="top"
														overlay={
															<Tooltip id="reviewTooltip">
																Request Review
															</Tooltip>
														}
													>
														<div onClick={() => handleAction(supplierClient.clientID, "Review requested")} />
													</OverlayTrigger>
												</> :
												<React.Fragment>
													{"No actions required"}
													<button className="btnBgBlueTextGradient" onClick={(e) => navigate("/home/suppliers/supplierProfile/" + props.supplier._id)}>
														Profile</button>
												</React.Fragment>
											}
										</span>
										<span className="clientTitle">Action</span>
									</div>
								)

							case "Admin client":
							case "Admin Compliance manager":
								const clientEntitiesIDs = props.clients && props.clients.find(client => client._id.toString() === props.userLogged.dataID.toString()).entities.map(entity => entity._id.toString())
								return (
									clientEntitiesIDs && clientEntitiesIDs.includes(supplierClient.clientID) && <div key={index} className="clientRow">
										<span className="clientHeaderTitle">{props.clients.find(clients => clients.entities.find(entity => entity._id === supplierClient.clientID)).entities.find(entity => entity._id === supplierClient.clientID).entityName}</span>
										<span className={`clientValue ${(() => {
											switch (supplierClient.status) {
												case "Active":
												case "Ready for review":
													return "success"

												case "Pre-authorized":
												case "Review requested":
													return "pending"

												case "New request":
													return "new"

												case "Rejected":
													return "failed"

												default:
													break;
											}
										})()}`}>
											{supplierClient.status}
										</span>
										<span className="clientTitle">Status</span>
										<span className="clientValue actions">
											{supplierClient.status === "Ready for review" || supplierClient.status === "Pre-authorized" || supplierClient.status === "Review requested" ?
												<>
													<OverlayTrigger placement="top"
														overlay={
															<Tooltip id="activeTooltip">
																Active
															</Tooltip>
														}
													>
														<div onClick={() => handleAction(supplierClient.clientID, "Active")} />
													</OverlayTrigger>
													<OverlayTrigger placement="top"
														overlay={
															<Tooltip id="authorizeTooltip">
																Authorize
															</Tooltip>
														}
													>
														<div onClick={() => handleAction(supplierClient.clientID, "Authorized")} />
													</OverlayTrigger>
													<OverlayTrigger placement="top"
														overlay={
															<Tooltip id="rejectTooltip">
																Reject
															</Tooltip>
														}
													>
														<div onClick={() => handleAction(supplierClient.clientID, "Rejected")} />
													</OverlayTrigger>
													<OverlayTrigger placement="top"
														overlay={
															<Tooltip id="reviewTooltip">
																Request Review
															</Tooltip>
														}
													>
														<div onClick={() => handleAction(supplierClient.clientID, "Review requested")} />
													</OverlayTrigger>
												</> :
												"No actions required"
											}
										</span>
										<span className="clientTitle">Action</span>
									</div>
								)

							default:
								return null
						}
					})}
				</div>

				<div className="commentActions">
					<button className="btnBgBlueTextGradient" onClick={props.onHide}>Close</button>
				</div>
			</Modal.Body>
		</Modal >
	)
}

// MODAL TO SHOW ALL THE SUPPLIER INDUSTRIES
function SupplierIndustriesModalReviewForAuth(props) {
	const { show, onHide, supplierIndustries } = props
	return (
		<Modal
			className="supplierIndustriesModalReviewForAuth"
			size="lg"
			centered
			show={show}
			onHide={onHide}
		>
			<Modal.Body>
				<h4 className="commentTitle">Industries</h4>

				<div className="industriesContainer">
					{supplierIndustries.map((industry, index) => (
						<span key={index} className="industry">{industry}</span>
					))}
				</div>

				<div className="actionButton">
					<button className="btnBgBlueTextGradient" onClick={onHide}>Close</button>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default function ReviewForAuth({ darkLightMode }) {
	// VARIABLES TO MANAGE THE USER LOGGED
	const { user } = useAuth()
	const userLogged = user?.selectedProfile
	const fromAlerts = useLocation()

	const [key, setKey] = useState(() => {
		const searchParams = new URLSearchParams(fromAlerts.search)
		const paramsExist = searchParams.get("fromAlerts")

		return paramsExist === "doc" ? "Document compliance" : 'Information Completed'
	});

	// VARIABLE TO SHOW THE CLIENTS MODAL
	const [showClientsModal, setShowClientsModal] = useState(() => {
		const searchParams = new URLSearchParams(fromAlerts.search)
		const paramsExist = searchParams.get("fromAlerts")


		return paramsExist === "review" && userLogged && (userLogged.rol !== "Client")
	})

	function updateModal() {
		const root = document.getElementById('root');
		const someChild = document.querySelector('.modal .modal-content');

		if (!someChild) return

		if (someChild && root.querySelector('.darkMode')) {
			// Define a function to apply styles
			const applyStyle = (elements, styles) => {
				elements.forEach(ele => {
					Object.entries(styles).forEach(([key, value]) => {
						ele.style[key] = value;
					});
				});
			};

			// Apply styles to someChild
			applyStyle([someChild], {
				backgroundColor: '#131E29',
				webkitTextFillColor: '#FFFFFF'
			});

			// Define common styles for inputs and headers
			const commonInputStyle = {
				background: '#27343F'
			};

			// Apply styles to table header, inputs, and dropdowns
			applyStyle(document.querySelectorAll('.modal .modal-content th, .modal .modal-content .inputContainer > input, .modal .modal-content .inputContainer > textarea, .modal .modal-content .inputContainer .dropdown-toggle, .modal .modal-content .infoContainer > input'), commonInputStyle);

			// Apply styles to dropdown items
			applyStyle(document.querySelectorAll('.modal .modal-content .dropdown-item'), commonInputStyle);

			// Apply styles to actions
			applyStyle(document.querySelectorAll('.modal .modal-content .actions > div'), {
				backgroundColor: '#FFFFFF'
			});

			// Apply styles to action dropdowns
			applyStyle(document.querySelectorAll('.modal .modal-content .actions .dropdown .dropdown-toggle, .modal .modal-content .actions .dropdown .newAlone, .modal .modal-content .actions .dropdown .successAlone, .modal .modal-content .actions .dropdown .pendingAlone'), commonInputStyle);

			// Define text fill colors for action dropdowns
			const dropdownColors = {
				'.newAlone': '#00A3FF',
				'.successAlone': '#08D1A1',
				'.pendingAlone': '#FF7B31'
			};

			Object.entries(dropdownColors).forEach(([selector, color]) => {
				applyStyle(document.querySelectorAll(`.modal .modal-content .actions .dropdown ${selector}`), {
					webkitTextFillColor: color,
					backgroundColor: commonInputStyle.background
				});
			});
		}
	}

	useEffect(() => {
		if (showClientsModal) {
			const timer = setTimeout(() => {
				updateModal();
			}, 200); // Small timeout to wait for the next render

			return () => clearTimeout(timer); // Cleanup the timeout on unmount
		}
	}, [showClientsModal]);

	useEffect(() => {
		const cleanedUrl = fromAlerts.pathname.split("?")[0];
		window.history.replaceState(null, "", cleanedUrl);
	}, [])

	// VARIABLE TO SHOW THE INDUSTRIES MODAL
	const [showIndustriesModal, setShowIndustriesModal] = useState(false)

	// VARIABLE TO MANAGE SUPPLIER INFO
	const [supplier, setSupplier] = useState(null);

	const [showAddUserModal, setShowAddUserModal] = useState(false)

	// VARIABLES TO CONTROL THE PERCERT COMPLETED FOR THE TABS
	const [informationCompliancePercent, setInformationCompliancePercent] = useState(0)
	const [documentCompliancePercent, setDocumentCompliancePercent] = useState(0)
	const [historicDocumentCompliancePercent, setHistoricDocumentCompliancePercent] = useState(0)

	const [users, setUsers] = useState([])

	const { id } = useParams();
	const navigate = useNavigate();

	const { supplierData, serverDate, clients, users: usersData, username } = useReviewForAuthData({ id, userLogged })
	const { handleSaveInfo, handleStatusChange, handleUpdateSupplierStatus } = useReviewForAuthMutations({ id, userLogged })

	const hasCheckedRedirect = useRef(false)

	useEffect(() => { if (supplierData) setSupplier(supplierData) }, [supplierData])
	useEffect(() => { if (usersData) setUsers(usersData) }, [usersData])
	useEffect(() => {
		if (!supplierData || hasCheckedRedirect.current) return
		hasCheckedRedirect.current = true
		const isPreAuthorized = supplierData.clients.some(client => client.status === "Pre-authorized")
		const isReadyForReview = supplierData.clients.some(client => client.status === "Ready for review")
		if (!isPreAuthorized && !isReadyForReview) {
			navigate("/home/suppliers/supplierProfile/" + id)
		}
	}, [supplierData])

	useEffect(() => {
		if (!supplier || !serverDate) return
		setInformationCompliancePercent(checkInformationCompliance(supplier.informationCompliance))
		setDocumentCompliancePercent(supplier.documentCompliancePercent ?? 0)
		setHistoricDocumentCompliancePercent(supplier.historicDocumentCompliancePercent ?? 0)
		supplier.informationCompliance.generalInformation.hasRepse && evaluateStaffCompliancy()
	}, [supplier, serverDate])

	useEffect(() => {
		supplier && supplier.informationCompliance.generalInformation.hasRepse && serverDate && evaluateStaffCompliancy()
	}, [key])

	// SEND NEW COMMENTS NOTIFICATION TO SUPPLIER
	const sendNotification = (email) => {
		const data = {
			email
		}

		Swal.fire({
			title: "Send email to supplier?",
			icon: "?",
			// showCancelButton: true,
			confirmButtonText: "Send email"
		}).then((result) => {
			if (result.isConfirmed) {
				axios.post(URI_NOTIFICATION, data).then(res => {
					Swal.fire({
						toast: true,
						icon: 'success',
						text: 'Email sent',
						showConfirmButton: false,
						timer: 2000,
						timerProgressBar: true,
						position: "bottom-end"
					})
				}).catch(err => {
					console.log("Error al enviar correo")
				})
			}
		});

	}

	// FUNCTION TO EVALUATE IF THE STAFF IS COMPLIANT AND CHANGE THE STAFF TAB
	const evaluateStaffCompliancy = () => {
		const element = document.getElementById("controlled-tab-example-tab-staff")

		const copySupplier = JSON.parse(JSON.stringify(supplier))

		const supplierList = copySupplier.staffs.filter(staff => staff.active && !staff.payrollReceipts.some(receipt => receipt.monthCreatedAt === serverDate.month && receipt.yearCreatedAt === serverDate.year))

		if (supplierList.length > 0) {
			element.classList.add("nonCompliant")
		} else {
			element.classList.remove("nonCompliant")
		}
	}

	return (
		<section className={`reviewForAuth ${darkLightMode ? "darkMode" : null}`}>
			<div className="header">
				<div className="generalInformation">
					<div className="headInformation">
						<img className="goBack" src={back} alt="Prodensa Supplier" onClick={() => navigate(-1)} />
						<img className="profilePhoto" src={
							supplier && supplier.informationCompliance.generalInformation.profilePhoto.document && !supplier.informationCompliance.generalInformation.profilePhoto.document.name
								? process.env.REACT_APP_URI_UPLOADS + supplier.informationCompliance.generalInformation.rfc + "/" + supplier.informationCompliance.generalInformation.profilePhoto.document
								: profileExample
						} alt="Prodensa Supplier" />
						<h3>
							{supplier && supplier.informationCompliance.generalInformation.companyName}
							<span>All time document compliant: {historicDocumentCompliancePercent}%</span>
						</h3>
						<h4 className="ratingValue">
							{supplier && supplier.rating ? supplier.rating.$numberDecimal : "Unrated"}
							{supplier && supplier.rating && supplier.rating.$numberDecimal ? <img className="ratingImg" src={starRating} alt="Prodensa Supplier" /> : undefined}
						</h4>
					</div>
					<div className="industriesInformation">
						<div className="industriesContainer">
							{supplier && supplier.informationCompliance.facilitiesCapabilities.categories.map((category, index) => (
								index < 4 && <span key={index}>{category}</span>
							))}
						</div>
						{supplier && supplier.informationCompliance.facilitiesCapabilities.categories.length > 3 && <button className="btnBgBlueTextGradient" onClick={() => setShowIndustriesModal(true)}>
							See all ({supplier && supplier.informationCompliance.facilitiesCapabilities.categories.length})
						</button>}
					</div>
					<p className="description">{supplier && supplier.informationCompliance.facilitiesCapabilities.description}</p>
					{(userLogged?.rol === "Client" || userLogged?.rol === "Compliance manager") && <div className="actions">
						<button className="btnBgBlueTextGradient" onClick={() => { handleUpdateSupplierStatus(supplier, userLogged.dataID, "Active") }}>Active supplier</button>
						<button className="btnBgBlueTextGradient" onClick={() => { handleUpdateSupplierStatus(supplier, userLogged.dataID, "Authorized") }}>Authorize supplier</button>
						<button className="btnBgBlueTextGradient" onClick={() => { handleUpdateSupplierStatus(supplier, userLogged.dataID, "Rejected") }}>Reject supplier</button>
						<button className="btnBgBlueTextGradient" onClick={() => { handleUpdateSupplierStatus(supplier, userLogged.dataID, "Review requested") }}>Request review</button>
					</div>}

					<div className="actionsContainer">
						{(userLogged?.rol === "Master" || userLogged?.rol === "Super admin" || userLogged?.rol === "Admin client" || userLogged?.rol === "Admin Compliance manager") && <button className="btnBgBlueTextGradient" onClick={() => setShowClientsModal(true)}>
							View actions for clients
						</button>}

						<OverlayTrigger placement="top"
							overlay={<Tooltip id="send-email-tooltip">
								Send email to supplier
							</Tooltip>}>
							<button className="btnBgBlueTextGradient send-email"
								onClick={() => sendNotification(supplier.informationCompliance.generalInformation.contactInformation.email)}
							>
								Send comments
							</button>
						</OverlayTrigger>
					</div>
				</div>

				<div className="contactInformation">
					{supplier && supplier.informationCompliance.generalInformation.cvp.certified && <img className="cvpBadge" src={cvpBadge} alt="Prodensa Supplier" />}
					<div className="info">
						<span className="infoTitle">Address</span>
						<span className="infoText">
							{supplier && supplier.informationCompliance.generalInformation.address.streetAndNumber}<br />
							C.P. {supplier && supplier.informationCompliance.generalInformation.address.zipCode}<br />
							{supplier && supplier.informationCompliance.generalInformation.address.city + " " + supplier.informationCompliance.generalInformation.address.state}

						</span>
					</div>
					<div className="info">
						<span className="infoTitle">Contact information</span>
						<span className="infoText">
							{supplier && supplier.informationCompliance.generalInformation.contactInformation?.name}<br />
							{supplier && supplier.informationCompliance.generalInformation.contactInformation?.email}<br />
							{supplier && supplier.informationCompliance.generalInformation.contactInformation?.phone}
						</span>
					</div>
					<div className="info">
						<span className="infoTitle">Website</span>
						<span className="infoText">{supplier && supplier.informationCompliance.generalInformation.website}</span>
					</div>
				</div>
				{(userLogged?.rol === "Client" || userLogged?.rol === "Compliance manager") && <div className="actions d-lg-none">
					<button className="btnBgBlueTextGradient" onClick={() => { handleUpdateSupplierStatus(supplier, userLogged.dataID, "Active") }}>Active supplier</button>
					<button className="btnBgBlueTextGradient" onClick={() => { handleUpdateSupplierStatus(supplier, userLogged.dataID, "Authorized") }}>Authorize supplier</button>
					<button className="btnBgBlueTextGradient" onClick={() => { handleUpdateSupplierStatus(supplier, userLogged.dataID, "Rejected") }}>Reject supplier</button>
					<button className="btnBgBlueTextGradient" onClick={() => { handleUpdateSupplierStatus(supplier, userLogged.dataID, "Review requested") }}>Request review</button>
				</div>}
				{(userLogged?.rol === "Master" || userLogged?.rol === "Super admin" || userLogged?.rol === "Admin client" || userLogged?.rol === "Admin Compliance manager") && <button className="btnBgBlueTextGradient d-lg-none" onClick={() => setShowClientsModal(true)}>
					View actions for clients
				</button>}

				<OverlayTrigger placement="top"
					overlay={<Tooltip id="send-email-tooltip">
						Send email to supplier
					</Tooltip>}>
					<button className="btnBgBlueTextGradient send-email d-lg-none"
						onClick={() => sendNotification(supplier.informationCompliance.generalInformation.contactInformation.email)}
					>
						Send comments
					</button>
				</OverlayTrigger>
			</div>

			<div className="tabs-container">
				<Tabs
					id="controlled-tab-example"
					activeKey={key}
					onSelect={(k) => setKey(k)}
				>
					<Tab eventKey="Information Completed" title={`1 Information Completed (${informationCompliancePercent}%)`}>
						{supplier && serverDate && <InformationCompliance
							supplier={supplier}
							informationCompliance={supplier.informationCompliance}
							setSupplier={setSupplier}
							username={username}
							serverDate={serverDate}
							handleSaveChanges={handleSaveInfo}
						/>}
					</Tab>
					<Tab eventKey="Document compliance" title={`2 Document compliance (${documentCompliancePercent}%)`}>
						{supplier && <DocumentComplianceTable
							supplier={supplier}
							setSupplier={setSupplier}
							serverDate={serverDate}
							handleSaveChanges={handleSaveInfo}
							userLogged={userLogged}
							darkLightMode={darkLightMode}
						/>}
					</Tab>
					{supplier?.informationCompliance?.generalInformation?.hasRepse && (
						<Tab eventKey="staff" title="3 Staff">
							{supplier && <StaffList
								supplier={supplier}
							/>}
						</Tab>
					)}
					<Tab eventKey="Quality Survey" title="4 Quality Survey">
						{supplier && <QualitySurvey
							qualitySurvey={supplier.qualitySurvey}
							setSupplier={setSupplier}
							rfc={supplier.informationCompliance.generalInformation.rfc}
						/>}
					</Tab>
					{userLogged?.rol !== "Admin Compliance manager" && userLogged?.rol !== "Compliance manager" &&
						<Tab eventKey="Products/Services" title="5 Products/Services">
							{supplier && serverDate && <ProductsAndServices
								darkLightMode={darkLightMode}
								supplier={supplier}
								productsAndServices={supplier.productsAndServices}
								setSupplier={setSupplier}
								serverDate={serverDate}
								userLogged={userLogged}
								rfc={supplier.informationCompliance.generalInformation.rfc}
								handleSaveChanges={handleSaveInfo}
							/>}
						</Tab>}
					<Tab eventKey="contracts" title="6 Contracts">
						{supplier && <Contracts
							supplier={supplier}
							clients={supplier.clients}
							setSupplier={setSupplier}
							serverDate={serverDate}
							userLogged={userLogged}
							rfc={supplier.informationCompliance.generalInformation.rfc}
							handleSaveChanges={handleSaveInfo}
						/>}
					</Tab>
					{supplier && (userLogged?.rol === "Master" || userLogged?.rol === "Super admin") &&
						<Tab eventKey="users" title="7 Users">
							<UsersTab
								users={users}
								setUsers={setUsers}
								supplierId={id}
							/>
						</Tab>}
				</Tabs>

				{(userLogged?.rol === "Master" || userLogged?.rol === "Super admin") && <button className="btnBgBlueTextGradient addUserButton"
					onClick={() => setShowAddUserModal(true)}
				>
					<img src={addIcon} alt="Prodensa Supplier" />
					Add user
				</button>}
			</div>

			{key !== "Document compliance" && <div className="actionButtons">
				<button className="btnBgBlueTextGradient" onClick={() => navigate(-1)}>Discard changes</button>
				<button className="btnBgBlueTextGradient" onClick={() => handleSaveInfo(supplier)}>Save changes</button>
			</div>}

			<button className="saveChanges" onClick={() => handleSaveInfo(supplier)}>
				<img src={save} alt="Prodensa Supplier" />
			</button>
			{supplier && clients && <SupplierClientsModalReviewForAuth
				supplier={supplier}
				supplierClients={supplier.clients}
				clients={clients}
				show={showClientsModal}
				onHide={() => setShowClientsModal(false)}
				handleStatusChange={handleStatusChange}
				userLogged={userLogged}
			/>}

			{supplier && <SupplierIndustriesModalReviewForAuth
				supplierIndustries={supplier.informationCompliance.facilitiesCapabilities.categories}
				show={showIndustriesModal}
				onHide={() => setShowIndustriesModal(false)}
			/>}

			{supplier && <AddClientUserModal
				darkLightMode={darkLightMode}
				show={showAddUserModal}
				onHide={() => setShowAddUserModal(false)}
				client={supplier}
				setUsers={setUsers}
			/>}
		</section>
	)
}